import { useEffect, useState } from 'react'

// 00:17:34 — restarts automatically when it reaches zero.
const DURATION_MS = (17 * 60 + 34) * 1000
const START = Date.now()

function getRemaining(): number {
  const elapsed = Date.now() - START
  return DURATION_MS - (elapsed % DURATION_MS)
}

export function useCountdown() {
  const [remaining, setRemaining] = useState<number>(getRemaining)

  useEffect(() => {
    const id = window.setInterval(() => setRemaining(getRemaining()), 250)
    return () => window.clearInterval(id)
  }, [])

  const totalSeconds = Math.ceil(remaining / 1000) % (DURATION_MS / 1000 + 1)
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  return {
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0'),
  }
}
